import moment from "moment";
// hàm filterDataByDayCareEndTime sử dụng chung cho màn hình bài tiết và check sheet.
export const filterDataByDayCareEndTime = (result:any) => {
  const now = moment();
  // lọc lại theo thời gian end_time của daycare.
  const filteredData = result.filter((item:any) => {
    const startTimeStr = item?.day_care?.start_time;
    const endTimeStr = item?.day_care?.end_time;
    const startTime = moment(startTimeStr);
    const endTime = moment(endTimeStr);
    return endTime.isAfter(now) && startTime.isBefore(now);
  });
  return filteredData;
}
